import './toggle.css'
import './App.css'
import { useBackground } from './BackgroundContext';
import { useEffect, useState } from 'react';

const Toggle = () => {
  const { setThemeByName } = useBackground();
  const [isScrolled, setIsScrolled] = useState(false);
  const { theme } = useBackground();
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  //fontcolor change to background
  const fontChange = {
    color: theme.fontColor
  }

  const hamburgerMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  const scrollToHome = () => {
    const homeElement = document.getElementById('home');
    if(homeElement) {
      homeElement.scrollIntoView({behavior: 'smooth'})
    }
  }

  const scrollToProjects = () => {
    const projectElement = document.getElementById('project');
    if(projectElement) {
      const yOffset = -100
      const y = projectElement.getBoundingClientRect().top + window.pageYOffset + yOffset
      window.scrollTo({ top: y, behavior: 'smooth'})
    }
  }

  const scrollToContacts = () => {
    const contactElement = document.getElementById('contact');
    if(contactElement) {
      contactElement.scrollIntoView({behavior: 'smooth'})
    }
  }

  const scrollToTech = () => {
    const contactElement = document.getElementById('tech');
    if(contactElement) {
      contactElement.scrollIntoView({behavior: 'smooth'})
    }
  }

  const scrollToMusic = () => {
    const contactElement = document.getElementById('Music');
    if(contactElement) {
      contactElement.scrollIntoView({behavior: 'smooth'})
    }
  }

  //Navbar changes color when scrolled
  const navbarStyle = {
    backdropFilter: isScrolled ? 'blur(20px)' : 'none',
    transition: 'background-color 0.3s ease', // optional: smooth transition
    display: 'flex',
    justifyContent: 'space-between',
    position: 'fixed',
    width: '100%',
    zIndex: '3',
    padding: '5px',
    alignItems: "center",
    backgroundColor: isScrolled ? 'transparent' : theme.background
  };

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 900)
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, [])

  // Handle button clicks to set the theme
  const handleThemeChange = (themeName) => {
    setThemeByName(themeName);
  };
  
    return (
<>
    <div style={navbarStyle} className="navbar">
      <div>
        <p style={{display: 'none'}}>Hello</p>
      </div>
      <div className="navbar-links" style={fontChange}>
        <span onClick={scrollToHome}>Home</span>
        <span onClick={scrollToProjects}>Projects</span>
        <span onClick={scrollToTech}>Tech Stack</span>
        <span onClick={scrollToMusic}>Music</span>
        <span onClick={scrollToContacts}>Contact</span>
      </div>
      <div className="toggle-buttons">
        {/* <button
          className="toggle-button-red"
          onClick={() => handleThemeChange("redTheme")}
        ></button> */}
        <button
          className="toggle-button-light"
          onClick={() => handleThemeChange("lightTheme")}
        ></button>
        <button
          className="toggle-button-dark"
          onClick={() => handleThemeChange("darkTheme")}
        ></button>
      </div>
      <button
        className="hamburger"
        onClick={hamburgerMenu}
        aria-label="Toggle navigation"
      >
        <i style={fontChange} className="fa-solid fa-bars"></i>
      </button>
    </div>

    {/* Fullscreen Menu Overlay */}
    <div className={`overlay ${isMenuOpen ? "show" : ""}`}>
      <button
        className="close-btn"
        onClick={hamburgerMenu}
        aria-label="Close navigation"
      >
        &times; {/* Unicode for close icon */}
      </button>
      <ul className="overlay-links">
        <div className="toggle-buttons overlay-buttons">
          {/* <button
            className="toggle-button-red"
            onClick={() => handleThemeChange("redTheme")}
          ></button> */}
          <button
            className="toggle-button-light"
            onClick={() => handleThemeChange("lightTheme")}
          ></button>
          <button
            className="toggle-button-dark"
            onClick={() => handleThemeChange("darkTheme")}
          ></button>
        </div>
        <li onClick={() => { scrollToHome(); hamburgerMenu(); }}>Home</li>
        <li onClick={() => { scrollToProjects(); hamburgerMenu(); }}>Projects</li>
        <li onClick={() => { scrollToTech(); hamburgerMenu(); }}>Tech Stack</li>
        <li onClick={() => { scrollToMusic(); hamburgerMenu(); }}>Music</li>
        <li onClick={() => { scrollToContacts(); hamburgerMenu(); }}>Contact</li>
      </ul>
    </div>
  </>
    );
  };


export default Toggle;